import api from '../apis/ufrnApi'

export const issueService = (issueId, limit = 10, offset = 0) => {
    let url = `/fasciculos?registro-sistema=${issueId}&limit=${limit}&offset=${offset}`
    return api.get(url)
}